/* Native Shopify storefront interactions. No external runtime dependencies. */
(() => {
  "use strict";
  const config = JSON.parse(
    document.getElementById("ThemeConfig")?.textContent || "{}",
  );
  const root = (config.root || "/").replace(/\/?$/, "/");
  const reduceMotion = matchMedia("(prefers-reduced-motion: reduce)");
  const desktop = matchMedia("(min-width: 990px)");
  const q = (selector, scope = document) => scope.querySelector(selector);
  const qa = (selector, scope = document) => [
    ...scope.querySelectorAll(selector),
  ];
  const status = (text) => {
    const el = q("#ThemeStatus");
    if (el) el.textContent = text;
  };
  const moneyError = (error) =>
    typeof error?.message === "string" ? error.message : config.error;
  const opener = new WeakMap();
  const carouselCleanup = new WeakMap();
  let cartBusy = false;
  let wishlistGeneration = 0;
  let variantRequest;

  function openDialog(dialog, trigger) {
    if (!dialog || dialog.open) return;
    opener.set(dialog, trigger || document.activeElement);
    dialog.showModal();
    document.body.classList.add("dialog-open");
    q("[data-close-dialog]", dialog)?.focus();
  }
  function bindDialogs(scope = document) {
    qa("dialog", scope).forEach((dialog) => {
      if (dialog.dataset.bound) return;
      dialog.dataset.bound = "true";
      dialog.addEventListener("close", () => {
        if (!q("dialog[open]")) document.body.classList.remove("dialog-open");
        const trigger = opener.get(dialog);
        if (trigger?.isConnected) trigger.focus();
      });
      dialog.addEventListener("click", (event) => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (
          event.clientX < rect.left ||
          event.clientX > rect.right ||
          event.clientY < rect.top ||
          event.clientY > rect.bottom
        )
          dialog.close();
      });
    });
  }
  function closeMenus(except) {
    qa("[data-mega][open]").forEach((details) => {
      if (details !== except) details.open = false;
    });
  }
  function bindHeader(scope = document) {
    qa("[data-mega]", scope).forEach((details) => {
      if (details.dataset.bound) return;
      details.dataset.bound = "true";
      details.addEventListener("toggle", () => {
        if (details.open) closeMenus(details);
      });
      details.addEventListener("pointerenter", (event) => {
        if (desktop.matches && event.pointerType === "mouse") {
          closeMenus(details);
          details.open = true;
        }
      });
      details.addEventListener("pointerleave", (event) => {
        if (
          desktop.matches &&
          event.pointerType === "mouse" &&
          !details.contains(document.activeElement)
        )
          details.open = false;
      });
      details.addEventListener("focusout", (event) => {
        if (!details.contains(event.relatedTarget)) details.open = false;
      });
    });
  }
  function scrollHeader() {
    q(".header-group")?.classList.toggle("is-scrolled", scrollY > 8);
  }
  window.addEventListener("scroll", scrollHeader, { passive: true });
  desktop.addEventListener("change", () => {
    qa("[data-menu-toggle]").forEach((button) =>
      button.setAttribute("aria-expanded", "false"),
    );
    qa(".main-nav").forEach((nav) => nav.classList.remove("is-open"));
    closeMenus();
  });

  function initCarousels(scope = document) {
    qa("[data-carousel], [data-announcement]", scope).forEach((element) => {
      if (carouselCleanup.has(element)) return;
      const track = q("[data-track]", element);
      if (!track) return;
      const previous = q("[data-prev]", element);
      const next = q("[data-next]", element);
      const announcement = element.hasAttribute("data-announcement");
      const update = () => {
        if (previous) previous.disabled = track.scrollLeft <= 2;
        if (next)
          next.disabled =
            track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      const move = (direction) => {
        const first = track.firstElementChild;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        const distance = first
          ? first.getBoundingClientRect().width + gap
          : track.clientWidth;
        track.scrollBy({
          left: direction * distance,
          behavior: reduceMotion.matches ? "instant" : "smooth",
        });
      };
      const previousClick = () => move(-1);
      const nextClick = () => move(1);
      previous?.addEventListener("click", previousClick);
      next?.addEventListener("click", nextClick);
      track.addEventListener("scroll", update, { passive: true });
      const resize = new ResizeObserver(update);
      resize.observe(track);
      update();
      let timer;
      let paused = false;
      let hovering = false;
      let focused = false;
      const pauseButton = q("[data-pause]", element);
      const stop = () => clearInterval(timer);
      const start = () => {
        stop();
        if (
          !announcement ||
          element.dataset.autoplay !== "true" ||
          paused ||
          hovering ||
          focused ||
          reduceMotion.matches ||
          document.hidden ||
          window.Shopify?.designMode ||
          track.children.length < 2
        )
          return;
        timer = setInterval(
          () => {
            const atEnd =
              track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
            if (atEnd) track.scrollTo({ left: 0, behavior: "smooth" });
            else move(1);
          },
          Number(element.dataset.interval) || 5000,
        );
      };
      const enter = () => {
        hovering = true;
        stop();
      };
      const leave = () => {
        hovering = false;
        start();
      };
      const focus = () => {
        focused = true;
        stop();
      };
      const blur = (event) => {
        if (!element.contains(event.relatedTarget)) {
          focused = false;
          start();
        }
      };
      const pause = () => {
        paused = !paused;
        pauseButton.setAttribute("aria-pressed", String(paused));
        start();
      };
      element.addEventListener("pointerenter", enter);
      element.addEventListener("pointerleave", leave);
      element.addEventListener("focusin", focus);
      element.addEventListener("focusout", blur);
      pauseButton?.addEventListener("click", pause);
      document.addEventListener("visibilitychange", start);
      reduceMotion.addEventListener("change", start);
      start();
      carouselCleanup.set(element, () => {
        stop();
        resize.disconnect();
        track.removeEventListener("scroll", update);
        previous?.removeEventListener("click", previousClick);
        next?.removeEventListener("click", nextClick);
        element.removeEventListener("pointerenter", enter);
        element.removeEventListener("pointerleave", leave);
        element.removeEventListener("focusin", focus);
        element.removeEventListener("focusout", blur);
        pauseButton?.removeEventListener("click", pause);
        document.removeEventListener("visibilitychange", start);
        reduceMotion.removeEventListener("change", start);
        carouselCleanup.delete(element);
      });
    });
  }
  function initVideo(scope = document) {
    qa('[data-hero-video]', scope).forEach(video => {
      if (video.dataset.bound) return;
      video.dataset.bound = 'true';
      const mobile = matchMedia('(max-width: 749px)');
      const button = q('[data-video-pause]', video.parentElement);
      const sync = () => {
        button?.setAttribute('aria-pressed', String(video.paused));
        button?.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
        const label = q('[data-video-label]', button || video.parentElement);
        if (label) label.textContent = video.paused ? 'Play' : 'Pause';
      };
      const selectSource = () => {
        const sources = qa('source', video);
        const preferred = mobile.matches ? sources.filter(s => s.media && matchMedia(s.media).matches) : sources.filter(s => !s.media);
        const source = [...preferred, ...sources.filter(s => !s.media)].find(s => video.canPlayType(s.type));
        if (source && video.getAttribute('src') !== source.dataset.src) {
          video.src = source.dataset.src;
          video.load();
          if (!reduceMotion.matches && !window.Shopify?.designMode) video.play().catch(() => {});
        }
      };
      selectSource();
      const motion = () => { if (reduceMotion.matches) video.pause(); };
      mobile.addEventListener('change', selectSource);
      reduceMotion.addEventListener('change', motion);
      video.addEventListener('play', sync); video.addEventListener('pause', sync); sync();
      video._tbvCleanup = () => {mobile.removeEventListener('change',selectSource);reduceMotion.removeEventListener('change',motion);};
    });
  }

  async function requestJSON(path, options = {}) {
    const response = await fetch(path, {
      credentials: "same-origin",
      ...options,
    });
    const body = await response.json();
    if (!response.ok)
      throw new Error(
        typeof body.description === "string"
          ? body.description
          : body.message || config.error,
      );
    return body;
  }
  async function refreshCart(html) {
    if (!q("#CartDrawer")) return;
    if (!html) {
      const sections = await requestJSON(
        `${config.cartUrl}?sections=cart-drawer`,
      );
      html = sections["cart-drawer"];
    }
    if (!html) throw new Error(config.error);
    const parsed = new DOMParser().parseFromString(html, "text/html");
    const replacement = q("[data-cart-content]", parsed);
    const existing = q("#CartDrawer [data-cart-content]");
    if (!replacement || !existing) throw new Error(config.error);
    existing.replaceWith(replacement);
    qa("[data-cart-count]").forEach((count) => {
      count.textContent = replacement.dataset.count;
    });
  }
  async function changeCart(key, quantity, focusId) {
    if (cartBusy || !Number.isInteger(quantity) || quantity < 0) return;
    cartBusy = true;
    const drawer = q("#CartDrawer");
    const message = q("[data-cart-message]", drawer);
    if (message) message.textContent = "";
    q("[data-cart-content]", drawer)?.setAttribute("aria-busy", "true");
    try {
      const result = await requestJSON(`${root}cart/change.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: key,
          quantity,
          sections: ["cart-drawer"],
          sections_url: config.cartUrl,
        }),
      });
      await refreshCart(result.sections?.["cart-drawer"]);
      const previous = document.getElementById(focusId);
      (previous || q("[data-close-dialog]", drawer))?.focus();
    } catch (error) {
      if (message) message.textContent = moneyError(error);
      // A failed request may still have changed the server cart: resync without replaying it.
      try {
        await refreshCart();
      } catch (_) {
        /* Preserve the original error. */
      }
    } finally {
      q("[data-cart-content]", drawer)?.removeAttribute("aria-busy");
      cartBusy = false;
    }
  }
  async function addProduct(form) {
    if (cartBusy) return;
    cartBusy = true;
    const submit = q("[name=add]", form);
    const message = q("[data-form-message]", form);
    const payload = new FormData(form);
    payload.set("sections", "cart-drawer");
    payload.set("sections_url", config.cartUrl);
    submit.disabled = true;
    form.setAttribute("aria-busy", "true");
    if (message) {
      message.textContent = "";
      delete message.dataset.error;
    }
    let added = false;
    try {
      const result = await requestJSON(`${root}cart/add.js`, {
        method: "POST",
        body: payload,
      });
      added = true;
      await refreshCart(result.sections?.["cart-drawer"]);
      openDialog(q("#CartDrawer"), submit);
      status(config.added);
    } catch (error) {
      // Do not retry an add operation: that could add the same product twice.
      if (added) {
        window.location.assign(config.cartUrl);
        return;
      }
      if (message) {
        message.textContent = moneyError(error);
        message.dataset.error = "true";
      }
      try {
        await refreshCart();
      } catch (_) {
        /* Native cart remains accessible. */
      }
    } finally {
      const data = form.closest('section')?.querySelector('[data-variants], [data-ring-variants]');
      let available = Boolean(q('[name=id]', form)?.value);
      if (data) { try { const current = JSON.parse(data.textContent).find(v => String(v.id) === q('[name=id]', form)?.value); available = Boolean(current?.available); } catch (_) {} }
      submit.disabled = !available;
      form.removeAttribute("aria-busy");
      cartBusy = false;
    }
  }

  const wishlistKey = "eternel-studio:wishlist:v1";
  function savedProducts() {
    try {
      const data = JSON.parse(localStorage.getItem(wishlistKey) || "[]");
      return Array.isArray(data)
        ? [
            ...new Set(
              data.filter(
                (handle) =>
                  typeof handle === "string" && /^[a-z0-9-]+$/.test(handle),
              ),
            ),
          ].slice(0, 100)
        : [];
    } catch (_) {
      return [];
    }
  }
  function syncWishlist() {
    const handles = savedProducts();
    qa("[data-wishlist-toggle]").forEach((button) =>
      button.setAttribute(
        "aria-pressed",
        String(handles.includes(button.dataset.wishlistToggle)),
      ),
    );
  }
  async function renderWishlist() {
    const generation = ++wishlistGeneration;
    const content = q("[data-wishlist-content]");
    const message = q("[data-wishlist-message]");
    if (!content) return;
    const handles = savedProducts();
    if (message) message.textContent = "";
    content.replaceChildren();
    content.setAttribute("aria-busy", "true");
    if (!handles.length) {
      if (message) message.textContent = config.wishlistEmpty;
      content.removeAttribute("aria-busy");
      return;
    }
    // Four concurrent lookups keep larger wishlists from flooding the store.
    const slots = handles.map(() => {
      const slot = document.createElement("div");
      content.append(slot);
      return slot;
    });
    let cursor = 0;
    const worker = async () => {
      while (cursor < handles.length && generation === wishlistGeneration) {
        const index = cursor++;
        const handle = handles[index];
        try {
          const response = await fetch(
            `${root}products/${encodeURIComponent(handle)}?section_id=wishlist-card`,
            { credentials: "same-origin" },
          );
          if (!response.ok) throw new Error(config.error);
          const html = await response.text();
          if (generation !== wishlistGeneration) return;
          const card = q(
            ".product-card",
            new DOMParser().parseFromString(html, "text/html"),
          );
          if (!card) throw new Error(config.error);
          slots[index].replaceWith(card);
        } catch (_) {
          if (generation !== wishlistGeneration) return;
          const label = document.createElement("p");
          label.textContent = handle.replaceAll("-", " ");
          const button = document.createElement("button");
          button.type = "button";
          button.className = "text-button";
          button.textContent = config.remove;
          button.dataset.wishlistToggle = handle;
          slots[index].replaceChildren(label, button);
        }
      }
    };
    await Promise.all(
      Array.from({ length: Math.min(4, handles.length) }, worker),
    );
    if (generation === wishlistGeneration) {
      content.removeAttribute("aria-busy");
      syncWishlist();
    }
  }
  function toggleWishlist(handle) {
    const handles = savedProducts();
    const exists = handles.includes(handle);
    try {
      localStorage.setItem(
        wishlistKey,
        JSON.stringify(
          exists
            ? handles.filter((item) => item !== handle)
            : [...handles, handle].slice(-100),
        ),
      );
    } catch (_) {
      status(config.wishlistUnavailable);
      const message = q("[data-wishlist-message]");
      if (message) message.textContent = config.wishlistUnavailable;
      return;
    }
    syncWishlist();
    status(exists ? config.wishlistRemoved : config.wishlistSaved);
    if (q("#WishlistDrawer")?.open) renderWishlist();
  }
  window.addEventListener("storage", (event) => {
    if (event.key === wishlistKey) {
      syncWishlist();
      if (q("#WishlistDrawer")?.open) renderWishlist();
    }
  });

  document.addEventListener("click", async (event) => {
    const toggle = event.target.closest("[data-menu-toggle]");
    if (toggle) {
      const nav = document.getElementById(toggle.getAttribute("aria-controls"));
      const open = toggle.getAttribute("aria-expanded") !== "true";
      toggle.setAttribute("aria-expanded", String(open));
      nav?.classList.toggle("is-open", open);
    }
    const close = event.target.closest("[data-close-dialog]");
    if (close) close.closest("dialog")?.close();
    const launch = event.target.closest("[data-open-dialog]");
    if (launch) {
      openDialog(document.getElementById(launch.dataset.openDialog), launch);
      if (launch.dataset.openDialog === "WishlistDrawer") renderWishlist();
    }
    const cart = event.target.closest("[data-cart-open]");
    if (
      cart &&
      document.body.dataset.cartType === "drawer" &&
      q("#CartDrawer") &&
      !event.metaKey &&
      !event.ctrlKey &&
      !event.shiftKey &&
      event.button === 0
    ) {
      event.preventDefault();
      openDialog(q("#CartDrawer"), cart);
      try {
        await refreshCart();
      } catch (_) {
        window.location.assign(config.cartUrl);
      }
    }
    const wishlist = event.target.closest("[data-wishlist-toggle]");
    if (wishlist) toggleWishlist(wishlist.dataset.wishlistToggle);
    const remove = event.target.closest("[data-cart-remove]");
    if (remove) {
      event.preventDefault();
      changeCart(remove.dataset.key, 0, "");
    }
    const videoButton = event.target.closest("[data-video-pause]");
    if (videoButton) {
      const video = q("video", videoButton.parentElement);
      if (video?.paused) video.play().catch(() => {});
      else video?.pause();
    }
    if (!event.target.closest("[data-mega]")) closeMenus();
  });
  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    const details = event.target.closest("[data-mega][open]");
    if (details) {
      details.open = false;
      q("summary", details)?.focus();
      event.preventDefault();
    }
    const nav = q(".main-nav.is-open");
    if (nav && !q("dialog[open]")) {
      nav.classList.remove("is-open");
      const button = q("[data-menu-toggle]");
      button?.setAttribute("aria-expanded", "false");
      button?.focus();
    }
  });
  document.addEventListener("submit", (event) => {
    const form = event.target;
    if (
      form.matches("[data-product-form]") &&
      document.body.dataset.cartType === "drawer" &&
      q("#CartDrawer")
    ) {
      event.preventDefault();
      addProduct(form);
    }
    if (form.closest("#CartDrawer") && cartBusy) event.preventDefault();
  });
  document.addEventListener("change", async (event) => {
    const input = event.target;
    if (input.matches(".localization select")) input.form?.requestSubmit();
    if (input.matches("#CartDrawer [data-cart-quantity]")) {
      if (!input.checkValidity()) {
        input.reportValidity();
        return;
      }
      changeCart(input.dataset.key, Number(input.value), input.id);
    }
    if (input.matches("[data-option-select]")) {
      const container = input.closest("[data-product-section]");
      const section = container.closest(".shopify-section");
      const focusId = input.id;
      const selectedOption = input.selectedOptions[0];
      const productUrl =
        selectedOption?.dataset.productUrl || container.dataset.productUrl;
      if (
        new URL(productUrl, location.origin).pathname !==
        new URL(container.dataset.productUrl, location.origin).pathname
      ) {
        window.location.assign(productUrl);
        return;
      }
      const url = new URL(productUrl, location.origin);
      const selectedValues = qa("[data-option-select]", container).map(
        (select) => select.value,
      );
      url.searchParams.set("option_values", selectedValues.join(","));
      const savedProperties = qa('[name^="properties["]', container).map(
        (field) => [field.name, field.value],
      );
      const savedQuantity = q("[name=quantity]", container)?.value;
      const fetchUrl = new URL(url);
      fetchUrl.searchParams.set("section_id", container.dataset.productSection);
      variantRequest?.abort();
      variantRequest = new AbortController();
      container.setAttribute("aria-busy", "true");
      qa("[name=add], .shopify-payment-button button", container).forEach(
        (button) => {
          button.disabled = true;
        },
      );
      try {
        const response = await fetch(fetchUrl, {
          signal: variantRequest.signal,
          credentials: "same-origin",
        });
        if (!response.ok) throw new Error(config.error);
        const html = await response.text();
        const parsed = new DOMParser().parseFromString(html, "text/html");
        const replacement = parsed.getElementById(section.id);
        if (!replacement) throw new Error(config.error);
        section.replaceWith(replacement);
        history.replaceState({}, "", url);
        init(replacement);
        document.getElementById(focusId)?.focus({ preventScroll: true });
        savedProperties.forEach(([name, value]) => {
          const field = qa("input,textarea", replacement).find(
            (field) => field.name === name,
          );
          if (field) field.value = value;
        });
        const quantity = q("[name=quantity]", replacement);
        if (quantity && savedQuantity) {
          const original = quantity.value;
          quantity.value = savedQuantity;
          if (!quantity.checkValidity()) quantity.value = original;
        }
        window.Shopify?.PaymentButton?.init();
      } catch (error) {
        if (error.name !== "AbortError") window.location.assign(url);
      }
    }
  });
  function activateCategory(showcase, id, focus = false) {
    qa("[data-category-tab]", showcase).forEach((tab) => {
      const active = tab.dataset.categoryTab === id;
      tab.setAttribute("aria-selected", String(active));
      tab.tabIndex = active ? 0 : -1;
      if (active && focus) tab.focus();
    });
    qa("[data-category-panel]", showcase).forEach((panel) => {
      panel.hidden = panel.dataset.categoryPanel !== id;
    });
    qa("[data-category-description]", showcase).forEach((description) => {
      description.hidden = description.dataset.categoryDescription !== id;
    });
    qa("[data-category-choice]", showcase).forEach((choice) => {
      choice.classList.toggle(
        "is-active",
        choice.dataset.categoryChoice === id,
      );
    });
  }
  function initCategoryShowcases(scope = document) {
    qa("[data-category-showcase]", scope).forEach((showcase) => {
      if (showcase.dataset.enhanced) return;
      const tabs = qa("[data-category-tab]", showcase);
      if (!tabs.length) return;
      showcase.dataset.enhanced = "true";
      const list = q("[data-category-list]", showcase);
      list.setAttribute("role", "tablist");
      list.setAttribute("aria-orientation", "vertical");
      tabs.forEach((tab) => {
        const panel = q(
          '[data-category-panel="' + tab.dataset.categoryTab + '"]',
          showcase,
        );
        tab.setAttribute("role", "tab");
        tab.setAttribute("aria-controls", panel.id);
        panel.setAttribute("role", "tabpanel");
        panel.setAttribute("aria-labelledby", tab.id);
        panel.tabIndex = 0;
      });
      activateCategory(showcase, tabs[0].dataset.categoryTab);
      showcase.addEventListener("click", (event) => {
        const tab = event.target.closest("[data-category-tab]");
        if (!tab) return;
        event.preventDefault();
        activateCategory(showcase, tab.dataset.categoryTab);
      });
      showcase.addEventListener("keydown", (event) => {
        const tab = event.target.closest("[data-category-tab]");
        if (!tab) return;
        let index = tabs.indexOf(tab);
        if (event.key === "ArrowDown" || event.key === "ArrowRight")
          index = (index + 1) % tabs.length;
        else if (event.key === "ArrowUp" || event.key === "ArrowLeft")
          index = (index - 1 + tabs.length) % tabs.length;
        else if (event.key === "Home") index = 0;
        else if (event.key === "End") index = tabs.length - 1;
        else return;
        event.preventDefault();
        activateCategory(showcase, tabs[index].dataset.categoryTab, true);
      });
    });
  }
  function init(scope = document) {
    bindDialogs(scope);
    bindHeader(scope);
    initCarousels(scope);
    initCategoryShowcases(scope);
    initVideo(scope);
    syncWishlist();
    scrollHeader();
  }
  document.addEventListener("shopify:section:load", (event) =>
    init(event.target),
  );
  document.addEventListener("shopify:section:unload", (event) => {
    qa("[data-carousel], [data-announcement]", event.target).forEach(
      (element) => carouselCleanup.get(element)?.(),
    );
    qa("video", event.target).forEach((video) => { video.pause(); video._tbvCleanup?.(); });
  });
  document.addEventListener("shopify:block:select", (event) => {
    const block = event.target;
    const choice = block.closest("[data-category-choice]");
    if (choice)
      activateCategory(
        choice.closest("[data-category-showcase]"),
        choice.dataset.categoryChoice,
      );
    const track = block.closest("[data-track]");
    if (track)
      track.scrollTo({
        left: block.offsetLeft - track.offsetLeft,
        behavior: "instant",
      });
    const menu = block.closest("[data-mega]");
    if (menu) {
      closeMenus(menu);
      menu.open = true;
    }
  });
  // Restore server state after browser back/forward cache navigation.
  window.addEventListener("pageshow", (event) => {
    if (event.persisted) {
      syncWishlist();
      if (q("#CartDrawer")) refreshCart().catch(() => {});
    }
  });
  init();
})();
